import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Panel } from 'primereact/panel';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { growlErrors } from '../../../utils/NotificationUtil';
import { addJobProfile } from '../../../services/apps/JobProfileService';
import NewJobForm from './NewJobForm';
import { withAccount } from '../../../components/AccountContext';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';

class NewJobProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSaving: false,
      jobProfile: {},
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.saveJobProfile = this.saveJobProfile.bind(this);
  }

  handleInputChange(event) {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    const { jobProfile } = this.state;
    jobProfile[name] = value;

    this.setState({ jobProfile });
  }

  async saveJobProfile(jobProfile) {
    this.setState({ isSaving: true });
    const {
      currentAccount, history, growl, match,
    } = this.props;
    const { aid } = match.params;
    try {
      const res = await addJobProfile({
        ...jobProfile,
        accountId: aid,
      });

      const { id } = res.addJobProfile.jobProfile;

      this.setState({ isSaving: false });
      const redirectUrl = `/accounts/${currentAccount}/job-profiles/${id}`;
      history.push(redirectUrl);
    } catch (err) {
      this.setState({ isSaving: false });
      growlErrors(growl, err);
    }
  }

  render() {
    const { match } = this.props;
    const { isSaving } = this.state;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <FormattedMessage id="job.new" defaultMessage="New Job Profile">
              {text => (
                <Panel header={text}>
                  <NewJobForm saveJobProfile={this.saveJobProfile} isSaving={isSaving} match={match} />
                </Panel>
              )}
            </FormattedMessage>
          </div>
        </div>
      </div>
    );
  }
}

NewJobProfile.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(withAccount(withRouter(NewJobProfile)));
